import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionService } from '../../core/services/permission.service';
import { ActionType } from '../models/menu.model';

@Directive({
  selector: '[hasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private permissionService = inject(PermissionService);

  @Input() hasPermission!: { menuId: number; action: ActionType };

  ngOnInit(): void {
    const { menuId, action } = this.hasPermission;
    if (this.checkAction(menuId, action)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkAction(menuId: number, action: ActionType): boolean {
    switch (action) {
      case 'view':    return this.permissionService.canView(menuId);
      case 'create':  return this.permissionService.canCreate(menuId);
      case 'edit':    return this.permissionService.canEdit(menuId);
      case 'delete':  return this.permissionService.canDelete(menuId);
      case 'approve': return this.permissionService.canApprove(menuId);
      case 'export':  return this.permissionService.canExport(menuId);
      case 'import':  return this.permissionService.canImport(menuId);
      default:        return false;
    }
  }
}
